// Types pour les séances Fleurs de Bach

export interface BachFlowersSessionData {
  // A. Informations générales
  consultant_type: 'adult' | 'child';
  session_type: 'first' | 'followup';
  
  // B. Historique et suivi (reprise automatique depuis questionnaire)
  emotion_principale: string;
  duree_ressenti: string[];
  impact_principal: string[];
  impact_autre?: string;
  deja_utilise_bach: boolean;
  
  // C. Actualisation en début de consultation
  etat_emotionnel_evolution: 'identique' | 'evolue' | 'different';
  notes_actualisation?: string;
  
  // D. Écoute et exploration émotionnelle
  emotions_dominantes: string[];
  emotion_autre?: string;
  manifestations_comportements?: string;
  ressenti_profond?: string;
  notes_exploration?: string;
  
  // E. Objectif émotionnel
  objectif_emotionnel?: string;
  
  // F. Sélection des Fleurs de Bach
  fleurs_pressenties?: string;
  fleurs_retenues: {
    fleur1?: string;
    fleur2?: string;
    fleur3?: string;
    fleur4?: string;
    fleur5?: string;
    fleur6?: string;
    fleur7?: string;
  };
  justification_fleurs?: string;
  
  // G. Flacon personnalisé
  flacon_prepare: boolean;
  date_preparation?: string;
  posologie: '4gouttes4fois' | '16gouttesJour';
  duree_estimee?: string;
  
  // H. Observations praticien
  observations_praticien?: string;
}

// Options pour les émotions dominantes
export const EMOTIONS_DOMINANTES_OPTIONS = [
  { id: 'stress_anxiete', label: 'Stress / anxiété' },
  { id: 'peur', label: 'Peur' },
  { id: 'tristesse', label: 'Tristesse' },
  { id: 'colere_irritabilite', label: 'Colère / irritabilité' },
  { id: 'decouragement', label: 'Découragement' },
  { id: 'hypersensibilite', label: 'Hypersensibilité' },
  { id: 'manque_confiance', label: 'Manque de confiance' },
  { id: 'fatigue_emotionnelle', label: 'Fatigue émotionnelle' },
  { id: 'difficulte_lacher_prise', label: 'Difficulté à lâcher prise' },
  { id: 'autre', label: 'Autre' },
];

// Fonction pour créer des données de session par défaut
export const createDefaultBachFlowersSession = (): BachFlowersSessionData => ({
  consultant_type: 'adult',
  session_type: 'first',
  emotion_principale: '',
  duree_ressenti: [],
  impact_principal: [],
  deja_utilise_bach: false,
  etat_emotionnel_evolution: 'identique',
  emotions_dominantes: [],
  fleurs_retenues: {},
  flacon_prepare: false,
  posologie: '4gouttes4fois',
});

// Fonction pour pré-remplir depuis le questionnaire de bienvenue
export const prefillFromWelcomeQuestionnaire = (
  questionnaireResponses: Record<string, any>
): Partial<BachFlowersSessionData> => {
  const prefilled: Partial<BachFlowersSessionData> = {};
  
  if (questionnaireResponses.emotion_principale) {
    prefilled.emotion_principale = questionnaireResponses.emotion_principale;
  }
  
  if (questionnaireResponses.duree_ressenti) {
    prefilled.duree_ressenti = Array.isArray(questionnaireResponses.duree_ressenti)
      ? questionnaireResponses.duree_ressenti
      : [questionnaireResponses.duree_ressenti];
  }
  
  if (questionnaireResponses.impact_principal) {
    prefilled.impact_principal = Array.isArray(questionnaireResponses.impact_principal)
      ? questionnaireResponses.impact_principal
      : [questionnaireResponses.impact_principal];
  }
  
  if (questionnaireResponses.impact_autre) {
    prefilled.impact_autre = questionnaireResponses.impact_autre;
  }
  
  if (questionnaireResponses.deja_utilise_bach) {
    prefilled.deja_utilise_bach = Array.isArray(questionnaireResponses.deja_utilise_bach)
      ? questionnaireResponses.deja_utilise_bach.includes('oui')
      : questionnaireResponses.deja_utilise_bach === 'oui';
  }
  
  return prefilled;
};
